/**
 * Thin, mockable wrappers around imperative browser navigation.
 *
 * Side-effectful `window.location` navigation is otherwise awkward to unit test
 * (jsdom's `location` is non-configurable and its `assign` is a no-op), so
 * callers that must hard-navigate go through here and tests mock this module.
 */

/**
 * Hard-navigate the browser to `url`, tearing down the SPA and its in-memory
 * stores/caches. Use for auth/session boundaries (e.g. a mid-session 401) where
 * a clean reload is desired over a client-side route change.
 */
export const hardRedirect = (url: string): void => {
  window.location.assign(url);
};

/**
 * The current location as a relative URL (path + query + hash), suitable for
 * round-tripping through a `redirectUri` query param.
 */
export const currentRelativeUrl = (): string =>
  window.location.pathname + window.location.search + window.location.hash;
